import context from '@/context'
import { addAnswerToComment } from './utils/commentsUtils'

const initialState = {

  fetching: false,
  adding: false,
  comments: []
}

export const actionTypes = {

  ReportSubmissionCommentFetching: 'reportSubmissionComments/fetching',
  ReportSubmissionCommentFetched: 'reportSubmissionComments/fetched',
  ReportSubmissionCommentAdding: 'reportSubmissionComments/adding',
  ReportSubmissionCommentAdded: 'reportSubmissionComments/added',
  Error: 'reportSubmissionComments/error'
}

export const actionCreators = {

  getComments: (id) => (dispatch) => {
    dispatch({ type: actionTypes.ReportSubmissionCommentFetching, data: id })
    context.api.reportSubmissionCommentsService.getComments(id)
      .then(response => {
        dispatch({ type: actionTypes.ReportSubmissionCommentFetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },

  addComment: (newComment) => (dispatch) => {
    dispatch({ type: actionTypes.ReportSubmissionCommentAdding })
    context.api.reportSubmissionCommentsService.addComment(newComment)
      .then(() => {
        dispatch({ type: actionTypes.ReportSubmissionCommentAdded, data: newComment })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ReportSubmissionCommentFetching: return { ...state, fetching: true }
    case actionTypes.ReportSubmissionCommentFetched: return { ...state, fetching: false, comments: action.data }
    case actionTypes.ReportSubmissionCommentAdding: return { ...state, adding: true }
    case actionTypes.ReportSubmissionCommentAdded: return { ...state, adding: false, comments: addAnswerToComment(action.data, state.comments).comments }
    case actionTypes.Error: return { ...state, fetching: false, adding: false }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportSubmissionComments.js